import BaseResource from './index'

export default class OptionValueResource extends BaseResource {
    static endpoint = '/oasis/restv3/optionValues'
}
